export type CustomFieldType =
  | 'text'
  | 'textarea'
  | 'number'
  | 'boolean'
  | 'select'
  | 'multiselect'
  | 'date';

/** Definición de campo personalizado por categoría (`customFieldDefinitions`). */
export type CustomFieldDefinition = {
  id: string;
  companyId: string;
  categoryId: string;
  subcategoryId: string | null;
  key: string;
  label: string;
  type: CustomFieldType;
  options: string[];
  required: boolean;
  sortOrder: number;
  active: boolean;
  createdAt: Date;
  updatedAt: Date;
};

export type CustomFieldDefinitionInput = {
  categoryId: string;
  subcategoryId: string | null;
  key: string;
  label: string;
  type: CustomFieldType;
  options: string[];
  required: boolean;
  sortOrder: number;
  active: boolean;
};

export const CUSTOM_FIELD_TYPE_LABELS: Record<CustomFieldType, string> = {
  text: 'Texto corto',
  textarea: 'Texto largo',
  number: 'Número',
  boolean: 'Sí / No',
  select: 'Selección única',
  multiselect: 'Selección múltiple',
  date: 'Fecha',
};

export const OPTION_FIELD_TYPES: readonly CustomFieldType[] = [
  'select',
  'multiselect',
] as const;
